import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';

import { GET_USER } from './useGetUser.graphql';
import {
  IGetUserQueryGraphQLResponse,
  IGetUserQueryVariables,
  IHandleGetUserParams,
  IUseGetUser,
  IUseGetUserOptions,
} from './useGetUser.interfaces';

const useGetUser = (options?: IUseGetUserOptions): IUseGetUser => {
  const { fetchPolicy, onCompleted, onError, query, tokens } = options ?? ({} as IUseGetUserOptions);

  const [executeGetUserQuery, { fetchMore, loading: isLoading }] = useLoggedGeladaLazyQuery<
  IGetUserQueryGraphQLResponse,
  IGetUserQueryVariables
  >({
    options: {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: ({ user: { get: user } }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          user
        });
      },
      onError,
    },
    query: query ?? GET_USER,
    tokens,
  });


  const handleGetUser = async ({
    groupId,
    userId
  }: IHandleGetUserParams) => {
    await executeGetUserQuery({
      variables: {
        groupId,
        userId
      },
    });
  };

  return {
    handleGetUser,
    isLoading,
  };
};

export { useGetUser };
